var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ready
    ? _c(
        "div",
        [
          _vm._l(_vm.data, function(item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "form-row form-control-mobile mb-mobile-2",
                on: {
                  click: function($event) {
                    return _vm.clickAtSingleList(index)
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "mb-2",
                    class: {
                      "col-md-9": !_vm.disabled,
                      "col-md-8": _vm.disabled
                    },
                    staticStyle: { height: "38px" }
                  },
                  [
                    _c("div", { staticClass: "d-flex" }, [
                      _c(
                        "div",
                        { staticStyle: { flex: "1" } },
                        [
                          [
                            !_vm.disabled
                              ? _c("vue-bootstrap-autocomplete", {
                                  attrs: {
                                    data: (function() {
                                      return !item.sku_id &&
                                        !item.is_saving_product
                                        ? [
                                            {
                                              text: "",
                                              sku_code: "",
                                              value: ""
                                            }
                                          ].concat(_vm.optionSkus)
                                        : []
                                    })(),
                                    serializer: function(item) {
                                      return (
                                        item.text + " " + (item.sku_code || "")
                                      )
                                    },
                                    minMatchingChars: 1,
                                    maxMatches: 10,
                                    placeholder: _vm.createAble
                                      ? _vm.$t("placeholder.selectorcreate")
                                      : _vm.$t("placeholder.selectitem"),
                                    loading: item.selectize.loading,
                                    state: (function() {
                                      if (item.selectize.trickValidation > 0) {
                                        return !item.sku_id ? false : null
                                      } else {
                                        return null
                                      }
                                    })(),
                                    disabled: item.is_saving_product
                                  },
                                  on: {
                                    input: function($event) {
                                      _vm.data[index].selectize.loading = true
                                      _vm.lookupProducts(index, $event)
                                    },
                                    hit: function($event) {
                                      return _vm.handleSelectProduct(
                                        index,
                                        $event
                                      )
                                    },
                                    blur: function($event) {
                                      return _vm.handleBlurProduct(
                                        index,
                                        $event
                                      )
                                    },
                                    inputBlur: function($event) {
                                      return _vm.handleInputBlurProduct(
                                        index,
                                        $event
                                      )
                                    },
                                    keydown: function($event) {
                                      return _vm.handleKeydownProduct(
                                        index,
                                        $event
                                      )
                                    },
                                    keyup: function($event) {
                                      return _vm.handleKeyupProduct(
                                        index,
                                        $event
                                      )
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "create",
                                        fn: function(ref) {
                                          var data = ref.data
                                          var htmlText = ref.htmlText
                                          return item.queryProductName
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      cursor: "pointer"
                                                    },
                                                    on: {
                                                      mousedown: function(
                                                        $event
                                                      ) {
                                                        return _vm.onAddedSku(
                                                          item.queryProductName
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-success"
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-plus"
                                                        }),
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.addnewproduct"
                                                              )
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#8f9295"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              item.queryProductName
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            : undefined
                                        }
                                      },
                                      {
                                        key: "suggestion",
                                        fn: function(ref) {
                                          var data = ref.data
                                          var htmlText = ref.htmlText
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-items-center"
                                              },
                                              [
                                                _c("img", {
                                                  staticStyle: {
                                                    width: "40px",
                                                    height: "40px",
                                                    "border-radius": "0.25rem"
                                                  },
                                                  attrs: {
                                                    src: _vm.productImage(
                                                      data.value
                                                    )
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex flex-column"
                                                  },
                                                  [
                                                    _c("span", {
                                                      staticClass: "ml-4",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          data.text
                                                        )
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "ml-4",
                                                      staticStyle: {
                                                        "font-size": "11px"
                                                      },
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          data.sku_code
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: item.queryProductName,
                                    callback: function($$v) {
                                      _vm.$set(item, "queryProductName", $$v)
                                    },
                                    expression: "item.queryProductName"
                                  }
                                })
                              : _c("input", {
                                  staticClass: "form-control",
                                  attrs: {
                                    disabled: _vm.disabled,
                                    type: "text"
                                  },
                                  domProps: { value: item.item }
                                })
                          ]
                        ],
                        2
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-2 mb-2" }, [
                  _c("div", { staticClass: "input-group" }, [
                    _c("div", { staticClass: "input-group-prepend" }, [
                      _c("span", { staticClass: "input-group-text" }, [
                        _vm._v(_vm._s(_vm.$t("message.quantity")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: item.quantity,
                          expression: "item.quantity"
                        }
                      ],
                      staticClass:
                        "form-control text-right number-only text-select-all",
                      attrs: {
                        disabled:
                          item.sku_id.length == 0 ||
                          _vm.disabled ||
                          _vm.isUseLot(item.sku_id) ||
                          _vm.isUseSerial(item.sku_id),
                        type: "text",
                        placeholder: ""
                      },
                      domProps: { value: item.quantity },
                      on: {
                        keypress: _vm.numberOnly,
                        keyup: function($event) {
                          item.quantity = _vm.setToValidNumber(item.quantity)
                        },
                        blur: function($event) {
                          item.quantity = _vm.setToCustomDigitsNumber(
                            item.quantity
                          )
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(item, "quantity", $event.target.value)
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _vm.disabled
                  ? _c("div", { staticClass: "col-md-2 mb-2" }, [
                      _c("div", { staticClass: "input-group" }, [
                        _c("div", { staticClass: "input-group-prepend" }, [
                          _c("span", { staticClass: "input-group-text" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("apps.inventory.message.deliveredcount")
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.done,
                              expression: "item.done"
                            }
                          ],
                          staticClass:
                            "form-control text-right number-only text-select-all",
                          class: {
                            "text-success": item.done >= item.quantity,
                            "text-danger": item.done < item.quantity
                          },
                          attrs: {
                            disabled: true,
                            type: "text",
                            placeholder: "0"
                          },
                          domProps: { value: item.done },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(item, "done", $event.target.value)
                            }
                          }
                        })
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.disabled
                  ? _c("div", { staticClass: "col-md-1 mb-2 text-center" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn col-12",
                          on: {
                            click: function($event) {
                              return _vm.del(index)
                            }
                          }
                        },
                        [_c("i", { staticClass: "far fa-trash-alt" })]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isUseLot(item.sku_id)
                  ? [
                      _c("BaseSelectLotNumber", {
                        style: _vm.disabled
                          ? "margin-bottom: -8px !important;"
                          : "",
                        attrs: {
                          index: index,
                          skuId: item.sku_id,
                          selected: item.lot.selected,
                          disabled: _vm.disabled,
                          label:
                            _vm.$t("apps.inventory.label.lotnumber") +
                            ": " +
                            _vm.$t("apps.inventory.label.pickfrom"),
                          selectedWhId: _vm.selectedWhIdFrom,
                          selectedBinId: _vm.pickedBinIdFrom
                        },
                        on: { onSubmit: _vm.handleSubmitLotNumber }
                      }),
                      _vm._v(" "),
                      _c("BaseGTPutAwayLot", {
                        attrs: {
                          warehouses: _vm.warehouses,
                          selectedWhId: _vm.selectedWhIdTo,
                          disabled: true,
                          label:
                            _vm.$t("apps.inventory.label.lotnumber") +
                            ": " +
                            _vm.$t("apps.inventory.label.putawayto")
                        },
                        model: {
                          value: item.lot,
                          callback: function($$v) {
                            _vm.$set(item, "lot", $$v)
                          },
                          expression: "item.lot"
                        }
                      })
                    ]
                  : _vm.isUseSerial(item.sku_id)
                  ? [
                      _c("BaseSelectSerialNumber", {
                        style: _vm.disabled
                          ? "margin-bottom: -8px !important;"
                          : "",
                        attrs: {
                          index: index,
                          skuId: item.sku_id,
                          selected: item.serial.selected,
                          disabled: _vm.disabled,
                          label:
                            _vm.$t("apps.inventory.label.serialnumber") +
                            ": " +
                            _vm.$t("apps.inventory.label.pickfrom"),
                          selectedWhId: _vm.selectedWhIdFrom,
                          selectedBinId: _vm.pickedBinIdFrom
                        },
                        on: { onSubmit: _vm.handleSubmitSerialNumber }
                      }),
                      _vm._v(" "),
                      _c("BaseGTPutAwaySerial", {
                        attrs: {
                          warehouses: _vm.warehouses,
                          selectedWhId: _vm.selectedWhIdTo,
                          disabled: true,
                          label:
                            _vm.$t("apps.inventory.label.serialnumber") +
                            ": " +
                            _vm.$t("apps.inventory.label.putawayto")
                        },
                        model: {
                          value: item.serial,
                          callback: function($$v) {
                            _vm.$set(item, "serial", $$v)
                          },
                          expression: "item.serial"
                        }
                      })
                    ]
                  : _vm._e()
              ],
              2
            )
          }),
          _vm._v(" "),
          !_vm.disabled
            ? _c("section", { staticClass: "mb-3" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn",
                    on: {
                      click: function($event) {
                        return _vm.add()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("button.addproduct")))]
                )
              ])
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ffca40e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffca40e6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/OrderGT.vue
// module id = null
// module chunks = 